import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { DestinacaoReservaModel } from '../../../../models/destinacao-reserva.model';
import { PessoaModel } from '../../../../models/pessoa.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';

@Injectable()
export class DR2008Pdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _cpf: CpfPipe
  ) { }

  public funcionarios( pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel,
    descricaoMesAno: string,
    destinacaoReservaModel: DestinacaoReservaModel,
    destinacaoReservaList: any[]) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(10);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`COMPROVANTE INDIVIDUAL DE PAGAMENTO \n
       PLANO BÁSICO DE BENEFÍCIOS - PBB
  DESTINAÇÃO DA RESERVA ESPECIAL - 2008
  REVERSÃO DE VALORES - PORTARIA PREVIC/DITEC-192/2011`, 105, 50, 'center')

    doc.autoTable({
      startY: 60
    })

    doc.autoTable({})


    doc.autoTable({
      theme: 'plain',
      didParseCell: function (data) {

        if (data.cell.raw === 'Mês / Ano'
          || data.cell.raw === 'Nº da Parcela') {
          data.cell.styles.fillColor = [226, 235, 248];
        }
      },
      headStyles: {
        fontSize: 8,
        halign: 'center'
      },
      styles: {
        fontSize: 8,
        halign: 'center'
      },
      columnStyles: {
        1: { cellWidth: 30 },
        2: { cellWidth: 30 }
      },
      head: [['', 'Mês / Ano', 'Nº da Parcela']],
      body: [[null, descricaoMesAno, destinacaoReservaModel.dsParcela]],
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 8,
      },
      styles: {
        fontSize: 8
      },
      columnStyles: {
        0: { cellWidth: 30 }
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform( pessoaDadosSimplicadosModel.cpf),  pessoaDadosSimplicadosModel.nome]],
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 8,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      styles: {
        fontSize: 8
      },
      willDrawCell: function (data) {
        if (data.row.section === 'body' && data.column.dataKey === 'descricao') {
          if (data.cell.raw === 'DESCONTOS') {
            doc.setFontStyle('bold')
            doc.setFontSize(9)

            data.cell.text = `                                DESCONTOS`
          }
        }

      },
      drawCell: function(cell, data) {
        if (data.column.dataKey === 'price' || data.column.dataKey === 'qty' || data.column.dataKey === 'price') {
          cell.styles.halign = 'right';
        }
      },
      head: this._headRows(),
      body: this._bodyRows(destinacaoReservaList)
    });


    doc.autoTable({})

    doc.setFontSize(9);
    doc.setFont('Source Sans Pro');
    doc.text(destinacaoReservaModel.dsMensagem, 70, doc.previousAutoTable.finalY + 4);

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 8,

      },
      styles: {
        fontSize: 8,
        halign: 'center'
      },
      head: [['Banco', 'Agência', 'Conta']],
      body: [[destinacaoReservaModel.dsBanco, destinacaoReservaModel.dsAgencia, destinacaoReservaModel.dsConta]],
    });


    doc.setProperties({
      title: 'Declaração',
      subject: `Declaração gerado em ${new Date('dd/mm/yyy')} `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
    ? (window.open(URL.createObjectURL(doc.output('blob'))))
    : this.handleFile(doc.output('blob'), 'declaracao2008.pdf');
}

handleFile(res: any, fileName: string) {
const file = new Blob([res], {
    type: res.type
});

// IE
if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file);
    return;
}



const blob = window.URL.createObjectURL(file);

const link = document.createElement('a');
link.href = blob;
link.download = fileName;

// link.click();
link.dispatchEvent(new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
}));

setTimeout(() => { // firefox
    window.URL.revokeObjectURL(blob);
    link.remove();
}, 100);
}

  private _bodyRows(destinacaoReservaList: any[]) {
    const body = []

    destinacaoReservaList.map(item => {
      body.push({
        descricao: item.descricao,
        valor: this._decimalPipe.transform(item.valor)
      })
    })
    return body;
  }

  private _headRows() {
    return [{
      descricao: 'Mês/Ano',
      valor: 'Valor'
    },
    ]
  }






}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008-pdf.ts